import { useQuery } from "@tanstack/react-query";
import { dashboardService } from "src/services";
import { is } from "src/util/is";

// Network KPI summary for the dashboard header tiles. An optional timeInterval
// scopes the time-based KPIs to a date range (else today).
export const useNetworkSummary = ({ teamId, timeInterval, enabled = true }) =>
  useQuery({
    queryKey: ["getNetworkSummary", teamId, timeInterval],
    queryFn: () => dashboardService.getNetworkSummary(teamId, timeInterval),
    enabled: !is.empty(teamId) && enabled,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
  });
